// extracted by mini-css-extract-plugin
module.exports = {"desc":"appVersion_desc__BlEuY","action":"appVersion_action__mePrK","button":"appVersion_button__qVYaJ"};